import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeContractStatuses } from './normalize';

export const fetchContractStatuses = createProvider(api.fetchContractStatuses).andThen(normalizeContractStatuses);
